import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-hardcopyactivity-audit-modal',
  templateUrl: './hardcopyactivity-audit-modal.component.html',
  styleUrls: ['./hardcopyactivity-audit-modal.component.scss']
})
export class HardcopyactivityAuditModalComponent {
  @Input() isHardCopyActivityAuditModalShow!: boolean;
  @Input() hardCopyActivityId: string = '';
  @Output() showHardCopyActivityAuditModal = new EventEmitter<boolean>();
  ngOnInit(): void {
  }
  closeHardCopyActivityAuditModal = () => {
    this.isHardCopyActivityAuditModalShow = false;
    this.showHardCopyActivityAuditModal.emit(false);
  }

}
